// The header is above the fold and must be interactive immediately.
import "../components/template-components/header/header.js";

// Non-critical enhancements (in-content hint toggles, the hints carousel and
// heading hyphenation) are deferred to idle time so they don't compete with the
// header and initial render on the main thread.
const loadEnhancements = () => {
	import("../components/elements/hint/hint.js");
	import("../components/patterns/hints/hints.js");
	import("./hyphenate.js");
};

if ("requestIdleCallback" in window) {
	requestIdleCallback(loadEnhancements, { timeout: 3000 });
} else {
	setTimeout(loadEnhancements, 200);
}
